import React from 'react';
import logo from '../../assets/images/logo.png';
import { send } from './services';

interface Form {
  id: string;
  token: string;
  refreshToken: string;
}

interface componentState {
  showPassword: boolean;
  typeInput: string;
  error: boolean;
  form: Form;
  loading: boolean;
}

export default class Loading extends React.Component<{}, componentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      showPassword: false,
      typeInput: 'password',
      error: false,
      loading: false,
      form: {
        id: '',
        token: '',
        refreshToken: ''
      }
    };
    this.getParametersFromUrl = this.getParametersFromUrl.bind(this);
  }

  componentDidMount(): void {
    this.getParametersFromUrl();
  }

  sendData(): void {
    send(this.state.form).then((response: any) => {
      this.setState({ error: false });
      if(response && response.phoneMutua){
        const url = process.env.REACT_APP_SERVER_URL_WHATSAPP_BASE + response.phoneMutua;
        window.location.href =  url as string;
      }else{
        window.location.href = process.env.REACT_APP_SERVER_URL_WHATSAPP as string;
      }
    });
  }

  getParametersFromUrl(): void {
    let url: URL = new URL(window.location.href);
    let id: string | null = url.searchParams.get("id");
    let token: string | null = url.searchParams.get("at");
    let refreshToken: string | null = url.searchParams.get("rt");
    let form: Form = this.state.form;
    form.id = id || '';
    form.token = token || '';
    form.refreshToken = refreshToken || '';
    this.setState({ form }, () => {
      this.sendData();
    });
  }

  render(): any {
    return (
      <div className="loading" >
        <div className="loading-header">
          <img src={logo} alt="logo"></img>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }
}
